import React from 'react';

import Button from '@material-ui/core/Button';

import classes from './BobCancelButton.module.css';

const BobCancelButton = ({
    cancel,
    children,
    className,
    label,
    disabled,
    hidden,
    onClick,
    ...props
}) => {

    if (hidden) {
        return null;
    }

    let content = children || label;

    if (!onClick && cancel) {
        onClick = cancel;
    }

    return (
        <Button
            data-test-id="cancel"
            variant="contained"
            type="button"
            disabled={disabled}
            className={`${classes.Button} ${className}`}
            onClick={onClick}
        >
            {content}
        </Button>
    );
};

export default BobCancelButton;
